export default __webpack_public_path__ + "static/media/unblind-test.bb5c722d.png";